'use strict';

module.exports = function hexdec(hexString) {
  //  discuss at: https://locutus.io/php/hexdec/
  // original by: Philippe Baumann
  //   example 1: hexdec('that')
  //   returns 1: 10
  //   example 2: hexdec('a0')
  //   returns 2: 160

  hexString = (hexString + '').replace(/[^a-f0-9]/gi, '');
  return parseInt(hexString, 16);
};
//# sourceMappingURL=hexdec.js.map


//////////////////
// WEBPACK FOOTER
// ./~/locutus/php/math/hexdec.js
// module id = 1201
// module chunks = 64